<template>
	<div style="height: 84vh;">
		<div class="tenant_search">
			<div class="tenant_search_1">
				<i></i>
				<el-input placeholder="请输入房间编号" prefix-icon="el-icon-search" v-model="data.room_num"></el-input>
			</div>
			<button class="search_button" @click="search()">搜索</button>
			<button class="search_button" @click="search('重置')">重置</button>
		</div>
		<ListingButton :lists="lists" @add='add' @dele='BatchDelete()'></ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			@BannerStatus="xiangqing" style="margin: 1rem;"></MyTable>
		<MyDialog :item="EditValue" :DialogTitle="DialogTitle" @changedia="changedia"
			:centerDialogVisible="centerDialogVisible"></MyDialog>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import MyDialog from "@/components/My_dialog/index.vue"
	import {
		water_list,
		water_delete
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'Metermanagement',
				lists: [{
					name: '添加',
					type: 'primary',
					icon: 'el-icon-plus',
					funt: 'add'
				}, {
					name: '删除',
					type: 'danger',
					icon: 'el-icon-delete',
					funt: 'dele'
				}, ],
				tableData: [],
				table_label: [{
					label: 'ID',
					value: 'id'
				}, {
					label: '房间号',
					value: 'room_num'
				}, {
					label: 'IP',
					value: 'ip'
				}, {
					label: '端口',
					value: 'port'
				}, {
					label: '剩余',
					value: 'residue'
				}, {
					label: '累计',
					value: 'total'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15,
					room_num: ""
				}
			}
		},
		methods: {
			search(resetting) {
				if (resetting != undefined) {
					this.data.room_num = ''
					this.contractlistcontractlist(this.data.page)
				} else {
					this.data.page = 1
					water_list(this.data).then(res => {
						console.log('res', res);
						if (res.status == 200) {
							this.tableData = res.data.list
							this.total = res.data.count
						}
					})
				}
			},
			contractlistcontractlist(value) {
				this.data.page = value ? value : this.data.page
				water_list(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
					}
				})
			},
			add() {
				this.centerDialogVisible = true
				this.DialogTitle = '添加水表'
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '编辑水表'
			},
			xiangqing(value) {
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '查看水表'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				water_delete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				people_delete({
					ids: [`${value.id}`]
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			changedia(value) {
				this.centerDialogVisible = value
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		components: {
			MyTable,
			ListingButton,
			MyDialog
		},
		created() {
			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: var(--cont_backgound);
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 4.8rem;
	}


	.tenant_search_1 .el-input {
		width: 10rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}
</style>